export const baseURL =
  process.env.REACT_APP_MODE === 'production'
    ? 'https://api.padaviation.com'
    : process.env.REACT_APP_MODE === 'stage'
    ? 'https://api-stage.padaviation.com'
    : 'http://localhost:8080'

export const flightprice = 100
